import React from 'react';
import {connect} from 'react-redux';
import PuffLoader from 'react-spinners/PuffLoader';
import {css} from '@emotion/react';
import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';
import * as Actions from '../../store/actions';
import {Modal, PrimaryButton, SecondaryButton} from '../../components';
import {deleteApiToken} from '../../requests/queries/tokens';

function DeleteTokenModal({open, setOpen, selectedToken}) {
  const queryClient = useQueryClient();

  const override = css`
    border-color: #ffffff;
    position: absolute;
    background: transparent;
  `;

  const {isLoading, mutate} = useMutation(data => {
    deleteApiToken(selectedToken?._id, data);
  });

  const handleSubmit = e => {
    e.preventDefault();

    mutate(
      {name: selectedToken?.name},
      {
        onSuccess: () => {
          toast.success('Token deleted successfully');
          setOpen(false);
          queryClient.invalidateQueries(['api-tokens']);
        },
        onError: error => {
          toast.error(error.response.data.error);
        },
      },
    );
  };

  return (
    <Modal
      show={open}
      onClose={setOpen}
      extraModalClasses="max-w-[528px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
      modalTitle="Delete token"
    >
      <form onSubmit={handleSubmit}>
        <p className="mt-4 text-sm text-left text-body px-6">
          By deleting this token, you are deleting every API calls and
          identifications and verifications done with the token.
        </p>

        <div className="w-full mt-6 px-6 py-[14px] border-[0.5px] flex gap-4 border-transparent border-t-[#EFEFEF]">
          <SecondaryButton
            className="w-[50%] !h-10"
            buttonText="Cancel"
            onClick={() => setOpen(false)}
          />{' '}
          <PrimaryButton
            type="submit"
            className="w-[50%] !h-10 bg-danger"
            buttonText="Delete"
            loading={isLoading}
          />
        </div>
      </form>
    </Modal>
  );
}

export default connect(state => state, Actions)(DeleteTokenModal);
